import React, { useState } from 'react';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle subscription logic here
    setEmail('');
  };
  return <section className="w-full bg-orla-sienna py-16 md:py-24" data-id="element-265">
      <div className="mx-auto flex max-w-[720px] flex-col items-center px-6 text-center md:px-8" data-id="element-266">
        <span className="font-body text-[13px] font-semibold uppercase tracking-[0.06em] text-orla-saffron" data-id="element-267">
          THE PRIME LETTER
        </span>

        <h2 className="mt-4 font-display text-[32px] font-black leading-[1.1] tracking-[-0.02em] text-orla-bone md:text-[48px]" data-id="element-268">
          Monthly notes from our physicians.
        </h2>

        <p className="mt-5 max-w-[520px] font-body text-[16px] leading-[1.6] text-orla-bone/80" data-id="element-269">
          A monthly letter from Orla physicians on perimenopause, hormone
          health, and everything women over 38 were never told.
        </p>

        <form onSubmit={handleSubmit} className="mt-10 flex w-full max-w-[480px] flex-col gap-3 md:flex-row md:gap-0" data-id="element-270">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required className="h-14 flex-grow rounded-full border-0 bg-orla-bone px-5 font-body text-orla-ink placeholder:text-orla-muted focus:outline-none focus:ring-2 focus:ring-orla-saffron md:rounded-r-none" data-id="element-271" />
          <button type="submit" className="h-14 rounded-full bg-orla-saffron px-8 font-body text-[15px] font-semibold text-orla-bone transition-colors hover:bg-orla-saffron/90 md:rounded-l-none" data-id="element-272">
            Subscribe
          </button>
        </form>

        <p className="mt-5 font-body text-[13px] text-orla-bone/60" data-id="element-273">
          No spam. Unsubscribe anytime.
        </p>
      </div>
    </section>;
}